export default __webpack_public_path__ + "static/media/loginbg.0ffbdc84.png";